// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__9cEXF","slider":"Switch_slider__A2yFe"};